import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { ProfilePicture, MembersInfoEdit } from "../../contents/htmlContent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Row,
  Col,
  Modal,
  ModalBody,
  Input,
  FormGroup,
  Label,
} from "reactstrap";
import Title from "../title";
import { Field } from "formik";
import Webcam from "react-webcam";
import { useDropzone } from "react-dropzone";
import Resizer from "react-image-file-resizer";
import { api } from "../../api/api";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import { store } from "../../redux/storeConfig/store";
import {
  getPayRatesType,
  getPayRates,
  getPayRatesByStaff,
} from "../../redux/actions/api/apiAction";
import deletenew from "../../assets/images/deletenew.svg";

const DropZone = ({ values, setFieldValue, errors }) => {
  const maxSize = 10485760;
  const onDrop = useCallback((acceptedFiles) => {
    //console.log(values);
    //console.log(acceptedFiles[0]);
    //console.log("acceptedFiles", acceptedFiles);
    let file = acceptedFiles[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async (event) => {
        //console.log(event.target.result);
        Resizer.imageFileResizer(
          file,
          300,
          300,
          "PNG",
          100,
          0,
          async (uri) => {
            let data = {
              fileName: acceptedFiles[0].name,
              source: uri,
              folder: "profile",
            };
            var url = await api(`file`, data, "post");
            if (url.data.status === 201) {
              //console.log(uri);
              setFieldValue("image", url.data.data);
            }
          },
          "base64",
          300,
          300
        );
      };
      reader.readAsDataURL(file);
    }
  }, []);
  const {
    isDragActive,
    getRootProps,
    getInputProps,
    isDragReject,
    acceptedFiles,
    rejectedFiles,
  } = useDropzone({
    onDrop,
    minSize: 0,
    maxSize: 10485760,
    accept: "image/*",
  });
  return (
    <div className="upload-profilephoto">
      <div className="file-input" {...getRootProps()}>
        <h6 className="upload-link mb-0">Upload Picture </h6>
        <input {...getInputProps()} />
      </div>
    </div>
  );
};

export const FormContent = (formikProps) => {
  const {
    errors,
    touched,
    values,
    setFieldValue,
    edit,
    gymId,
    loggedInGym,
    permissionsList,
    setSelectedCategories,
    selectCategories,
    categories,
  } = formikProps;

  const dispatch = useDispatch();

  const webcamRef = React.useRef(null);
  const [imgSrc, setImgSrc] = React.useState(null);
  const [phoneNumber, setPhoneNumber] = React.useState(values.phone);
  const [takePicture, setTakePicture] = React.useState(false);
  const [selectAll, setSelectedAll] = useState(false);
  const [payRatesSelected, setPayRatesSelected] = useState([]);
  const [payRatesRender, setPayRatesRender] = useState([]);
  const [selectedPayRateType, setSelectedPayRateType] = useState("");
  const [selectedPayRate, setSelectedPayRate] = useState("");
  const [isPayRatesSelected, setIsPayRatesSelected] = useState(false);
  const payRatesType = useSelector((state) => state.payRoll.payRatesType);
  const payRatesRend = useSelector((state) => state.payRoll.payRates);
  const payRatesStaff = useSelector((state) => state.payRoll.payRatesStaff);
  const { gymConfig } = useSelector((state) => state.gym);
  console.log({ selectCategories, per: values.permissions });
  const [groupedPermissions, setGroupedPermissions] = React.useState({});
  const capture = React.useCallback(async () => {
    const imageSrc = webcamRef.current.getScreenshot();
    let data = {
      fileName: "captured",
      source: imageSrc,
      folder: "profile",
    };
    var url = await api(`file`, data, "post");
    if (url.data.status === 201) {
      setFieldValue("image", url.data.data);
    }
    setImgSrc(imageSrc);
    setTakePicture(false);
  }, [webcamRef, setImgSrc]);

  useEffect(() => {
    if (store.getState().sidebar.staffEdit) {
      let {
        name,
        phone,
        image,
        email,
        permissions,
        title,
      } = store.getState().sidebar.staffFields;
      setFieldValue("name", name);
      setFieldValue("phone", phone);
      setPhoneNumber(phone);
      setFieldValue("image", image);
      setFieldValue("email", email);
      setFieldValue("title", title);
      setFieldValue(
        "permissions",
        permissions?.map((el) => el.id)
      );
      console.log({
        permissions: permissions.length,
        lis: permissionsList.length,
      });
      setSelectedAll(permissions.length === permissionsList.length);
    }
  }, []);
  useEffect(() => {
    if (store.getState().sidebar.staffEdit && permissionsList) {
      let { permissions } = store.getState().sidebar.staffFields;
      let custmPermission = permissions.map((itm) => itm.id);

      setFieldValue("permissions", custmPermission);
      setSelectedAll(custmPermission.length === permissionsList.length);
    }
    // Grouping the array by category
    let groupedPermissions = permissionsList.reduce((groups, item) => {
      let { category, ...rest } = item;
      if (!groups[category]) {
        if (!category) {
          category = "Not Categorized";
        }
        groups[category] = [];
      }
      groups[category].push(rest);
      return groups;
    }, {});

    let sortedGroupedPermissions = Object.entries(groupedPermissions)
      .sort((a, b) => a[1].length - b[1].length)
      .reduce((obj, [key, value]) => {
        obj[key] = value;
        return obj;
      }, {});

    setGroupedPermissions(sortedGroupedPermissions);
    console.log({ groupedPermissions, permissionsList });
  }, [permissionsList]);
  useEffect(() => {}, [selectCategories.length]);
  useEffect(() => {
    if (!permissionsList || !permissionsList.length) {
      return;
    }
    if (gymConfig?.manageStaff?.enabled && !gymConfig.manageStaff.manageStaffPermissions) {
      selectAllPermissions();
    }
  }, [gymConfig, permissionsList]);

  React.useEffect(() => {
    dispatch(getPayRatesType());
    const id = store.getState().sidebar.staffFields.id;
    if (id) dispatch(getPayRatesByStaff(id));
    console.log(id, "ididid");
    console.log(payRatesStaff, "payRatesStaffpayRatesStaff");
  }, [dispatch]);

  React.useEffect(() => {
    console.log(
      "Rendering due to payRatesSelected or formikProps.values.payRates changes"
    );
    const allPayRates = new Set([...payRatesSelected, ...payRatesStaff]);
    setPayRatesRender(Array.from(allPayRates));

    // Only update if necessary
    // if (payRatesSelected !== formikProps.values.payRates) {
    //     setPayRatesSelected(formikProps.values.payRates);
    // }
  }, [payRatesSelected]);

  const handlePayRateTypesChange = (e) => {
    console.log(e.target.value, "e.target.value");
    setSelectedPayRateType(e.target.value);
    dispatch(getPayRates(e.target.value));
  };

  const handlePayRateChange = async (e) => {
    const selectedId = parseInt(e.target.value, 10);
    setSelectedPayRate(e.target.value);

    if (!payRatesSelected) {
      setIsPayRatesSelected(false);
    }

    const selectedPayRate = payRatesRend.find(
      (payRate) => payRate.id === selectedId
    );
    if (
      selectedPayRate &&
      !payRatesSelected.some((payRate) => payRate.id === selectedId)
    ) {
      setPayRatesSelected((prev) => {
        const updatedPayRatesSelected = [...prev, selectedPayRate];

        setFieldValue("payRates", updatedPayRatesSelected);
        return updatedPayRatesSelected; // This returns the new state
      });
    } else {
      console.log("Pay rate already selected or not found");
    }
  };

  const selectAllPermissions = () => {
    const allPermissionIds = permissionsList.map(
      (itm) => parseInt(itm.id)
    );
    setFieldValue(
      "permissions",
      !selectAll ? allPermissionIds : []
    );
    setSelectedAll(!selectAll);
  };

  return (
    <>
      <div className=" bg-white card-panel">
        <div className="basic-info">
          <div className="info-title with-border">
            <Title
              title="Add Staff"
              subtitlestyle="ctf-tx-secondary"
              subtitle="Add info about the staff"
            />
          </div>
        </div>
        <div className="profile-image-block blk-padding-y border-bottom-1">
          <div className="profile-image-inner-block d-flex justify-content-center">
            <div className="profile-image-wrapper">
              {takePicture ? (
                <div className="captureimage">
                  <Webcam
                    audio={false}
                    ref={webcamRef}
                    screenshotFormat="image/jpeg"
                  />
                </div>
              ) : (
                <div className="profile-image">
                  <img
                    src={
                      values.image
                        ? values.image
                        : require("../../assets/images/no-image_user.jpg")
                    }
                    className="img-fluid img-blk"
                    alt="user"
                  />
                </div>
              )}

              <div className="profile-image-links">
                {/* <div className="links file-input-link">
                  <div
                    className="file-input"
                    onClick={() => {
                      takePicture ? capture() : setTakePicture(true);
                    }}
                  >
                    <h6 className="upload-link mb-0">
                      {!takePicture ? ProfilePicture.takePicture : "Capture"}
                    </h6>
                  </div>
                </div> */}
                <div className="links file-input-link">
                  <div className="file-input">
                    <DropZone
                      values={values}
                      setFieldValue={setFieldValue}
                      errors={errors}
                    />
                  </div>
                </div>
                <div className="links">
                  <h6
                    className="remove-link mb-0 text-uppercase"
                    onClick={async () => {
                      if (values.image) {
                        // await api(`file`, { url: values.image }, "delete");
                        setFieldValue("image", "");
                      }
                    }}
                  >
                    {ProfilePicture.removePicture}{" "}
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="member-info-wrapper info-wrapper border-bottom-1 blk-padding-y">
          <div className="info-title">
            <Title title={"Staff Info"} />
          </div>
          <div className="info trainer-info">
            <Row>
              <Col md={4}>
                <FormGroup className="custom-inputs ">
                  <Field
                    type="text"
                    name="name"
                    id="name"
                    maxLength={50}
                    disabled={edit && gymId !== loggedInGym}
                    placeholder="Staff name"
                    className={`form-control ${errors.name &&
                      touched.name &&
                      "is-invalid"}`}
                  />
                  {errors.name && touched.name ? (
                    <div className="invalid-feedback">{`${errors.name}`}</div>
                  ) : null}
                  <Label for="firstname" className="">
                    Staff name
                  </Label>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Field
                    type="text"
                    name="email"
                    id="username"
                    disabled={edit && gymId !== loggedInGym}
                    placeholder="user name "
                    className={`form-control ${errors.email &&
                      touched.email &&
                      "is-invalid"}`}
                  />
                  {errors.email && touched.email ? (
                    <div className="invalid-feedback">{`${errors.email}`}</div>
                  ) : null}
                  <Label> Username</Label>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Field
                    type="text"
                    name="title"
                    id="title"
                    placeholder="staff title "
                    className={`form-control ${errors.title &&
                      touched.title &&
                      "is-invalid"}`}
                  />
                  {errors.title && touched.title ? (
                    <div className="invalid-feedback">{`${errors.title}`}</div>
                  ) : null}
                  <Label> Staff Title</Label>
                </FormGroup>
              </Col>
              {/* <Col md={4}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Field
                    onChange={handlePayRateTypesChange}
                    required={payRatesSelected.length < 1}
                    value={selectedPayRateType}
                    as="select"
                    name="payratesType"
                    id="payratesType"
                    className={`form-control ${payRatesSelected.length < 1 &&
                      isPayRatesSelected &&
                      "is-invalid"}`}
                  >
                    <option value="">Select an option</option>
                    {payRatesType.length &&
                      payRatesType.map((type) => {
                        return <option value={type.id}>{type.name}</option>;
                      })}
                  </Field>
                </FormGroup>
              </Col>
              <Col md={4}>
                <FormGroup className="custom-inputs mb-md-0">
                  <Field
                    onChange={handlePayRateChange}
                    required={payRatesSelected.length < 1}
                    value={selectedPayRate}
                    as="select"
                    name="payrate"
                    id="payrate"
                    className={`form-control ${payRatesSelected.length < 1 &&
                      isPayRatesSelected &&
                      "is-invalid"}`}
                  >
                    <option value="">Select an option</option>
                    {payRatesRend &&
                      payRatesRend.map((payRate) => {
                        return (
                          <option value={payRate.id}>
                            {payRate.payrateName}
                          </option>
                        );
                      })}
                  </Field>
                  {payRatesSelected.length < 1 && isPayRatesSelected ? (
                    <div className="invalid-feedback">
                      Please select at least one pay rate
                    </div>
                  ) : null}
                </FormGroup>
              </Col> */}
              <Col md={4}>
                <FormGroup className="custom-inputs">
                  <PhoneInput
                    international
                    defaultCountry={
                      JSON.parse(
                        localStorage.getItem("connectToFitGymPanelUser")
                      ).country
                    }
                    // disabled={edit && gymId !== loggedInGym}
                    value={phoneNumber}
                    placeholder="Phone Number"
                    onChange={(value) => {
                      //console.log(value, "value of phone");
                      if (value) {
                        setPhoneNumber(value);
                        if (isValidPhoneNumber(value))
                          setFieldValue("phone", value);
                        else setFieldValue("phone", "");
                      }
                    }}
                    className={` ${errors.phone &&
                      touched.phone &&
                      "is-invalid"}`}
                  />
                  {errors.phone && touched.phone ? (
                    <div className="invalid-feedback">{`${errors.phone}`}</div>
                  ) : null}

                  <Label>Phone number</Label>
                </FormGroup>
              </Col>
              {/* <Col md={4}>
                <div className="d-flex flex-wrap" style={{ gap: "0.5rem" }}>
                  {payRatesRender.length > 0 &&
                    payRatesRender.map((payRate, i) => {
                      return (
                        <div
                          style={{
                            background: "#F6A51F",
                            borderRadius: "0.25rem",
                            display: "flex",
                            padding: "0.7rem 1rem",
                            color: "white",
                            gap: "1rem",
                          }}
                        >
                          <p>{payRate.payrateName}</p>
                          <img
                            style={{ cursor: "pointer" }}
                            src={deletenew}
                            onClick={() => {
                              setPayRatesSelected(
                                payRatesSelected.filter(
                                  (payRate, index) => index !== i
                                )
                              );
                              setPayRatesRender(
                                payRatesRender.filter(
                                  (payRate, index) => index !== i
                                )
                              );
                              setFieldValue(
                                "payRates",
                                payRatesSelected.filter(
                                  (payRate, index) => index !== i
                                )
                              );
                            }}
                          />
                        </div>
                      );
                    })}
                </div>
              </Col> */}
            </Row>
          </div>
        </div>

        <div className={`member-info-wrapper info-wrapper border-bottom-1 blk-padding-y ${gymConfig?.manageStaff?.enabled && !gymConfig.manageStaff.manageStaffPermissions ? 'disabled-card' : ''}`}>
          <div className="info-title">
            <Title title={"Staff Permissions"} />
          </div>
          <div className="info trainer-info">
            <Row>
              {permissionsList.length ? (
                <Col md={12}>
                  <div className="subscription-plan-list-element">
                    <div className="selction-box mt-0 px-0">
                      <div className="checkboxes-list form-check">
                        <label className="container-blk form-check-label">
                          <Field
                            className="form-check-input"
                            type="checkbox"
                            name="permissions"
                            checked={selectAll}
                            onChange={selectAllPermissions}
                          />
                          <span class="checkmark"></span>
                          select All{" "}
                        </label>
                      </div>
                    </div>
                  </div>
                </Col>
              ) : (
                <span style={{ fontSize: "14px", marginLeft: "15px" }}>
                  There are no categories selected yet !
                </span>
              )}
              {Object.keys(groupedPermissions).map((category) => (
                <>
                  <Col
                    key={category}
                    lg={3}
                    style={{
                      borderTop: "1px solid #eeeeee",
                      marginBottom: "10px",
                    }}
                  >
                    <div className="subscription-plan-list-element mt-4">
                      <div className="selction-box mt-0 px-0">
                        <div className="checkboxes-list form-check">
                          <label
                            style={{ fontSize: "16px", fontWeight: "bold" }}
                            id="permission-category"
                          >
                            {category}
                          </label>
                        </div>
                      </div>
                    </div>
                    {/* <span>{category}</span> */}
              
                    {/* Iterate over the permissions array for the current category */}
                    {groupedPermissions[category].map((permission, idx) => (
                      <Col md={12} lg={12}>
                        <div className="subscription-plan-list-element">
                          <div className="selction-box mt-0 px-0">
                            <div className="checkboxes-list form-check">
                              <label
                                className="container-blk form-check-label"
                                for={`checkbox${permission?.id}`}
                                id="permission-category"
                              >
                                <Field
                                  className="form-check-input"
                                  type="checkbox"
                                  name="permissions"
                                  id={`checkbox${permission?.id}`}
                                  value={permission.id}
                                  checked={
                                    values.permissions &&
                                    values.permissions.includes(permission.id)
                                  }
                                  onChange={(e) => {
                                    console.log({ permission, idx });
                                    const permissionId = parseInt(
                                      e.target.value
                                    );

                                    let updatedPermissions;
                                    let permissions = values.permissions
                                      ? [...values.permissions]
                                      : [];

                                    if (permissions.includes(permissionId)) {
                                      console.log(" include", permissions);
                                      // Add the permission if it's checked and not already in the list
                                      updatedPermissions = permissions.filter(
                                        (id) => id !== permissionId
                                      );
                                      console.log(
                                        " include",
                                        updatedPermissions
                                      );
                                    } else {
                                      console.log("not include");

                                      updatedPermissions = [
                                        ...permissions,
                                        permissionId,
                                      ];
                                      console.log(
                                        "not include",
                                        updatedPermissions
                                      );
                                    }
                                    setFieldValue(
                                      "permissions",
                                      updatedPermissions
                                    );
                                  }}
                                />
                                <span class="checkmark"></span>
                                {permission.name}
                              </label>
                            </div>
                          </div>
                        </div>
                      </Col>
                    ))}
                  </Col>
                </>
              ))}

              {/* {permissionsList &&
                permissionsList.map((itm, idx) => {
                  return (
                    <Col md={6}>
                      <div className="subscription-plan-list-element">
                        <div className="selction-box mt-0 px-0">
                          <div className="checkboxes-list form-check">
                            <label
                              className="container-blk form-check-label"
                              for={`checkbox${idx}`}
                              id="permission-category"
                            >
                              <Field
                                className="form-check-input"
                                type="checkbox"
                                name="permissions"
                                id={`checkbox${idx}`}
                                value={itm.id}
                                checked={
                                  values.permissions &&
                                  values.permissions.some(
                                    (obj) => obj.id == itm.id
                                  )
                                }
                                onChange={(e) => {
                                  const permissionId = e.target.value;
                                  console.log(
                                    values.permissions.some(
                                      (obj) => obj.id == itm.id
                                    )
                                  );
                            
                                  console.log({ e, permi: values.permissions });
                                  const updatedPermissions = values.permissions.some(
                                    (obj) => obj.id == itm.id
                                  )
                                    ? values.permissions.filter(
                                        (item) => item.id !== permissionId
                                      )
                                    : [
                                        ...values.permissions,
                                        {
                                          id: permissionId,
                                          category: itm.category,
                                        },
                                      ];

                                  setFieldValue(
                                    "permissions",
                                    updatedPermissions
                                  );
                                  setSelectedAll(
                                    updatedPermissions.length ===
                                      permissionsList.length
                                  );
                                }}
                              />
                              <span class="checkmark"></span>
                              {itm.name}
                            </label>
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                })} */}
              {errors.permissions && touched.hasOwnProperty("permissions") ? (
                <div className="invalid-feedback d-block ml-3">{`${errors.permissions}`}</div>
              ) : null}
            </Row>
          </div>
        </div>
      </div>
    </>
  );
};
